import type { AnimalKey, AnimalStats } from '../types';

const base = {
  speedRamp: 6,
  duckHitboxScale: 0.55,
};

export const ANIMAL_STATS: Record<AnimalKey, AnimalStats> = {
  horse: {
    key: 'horse',
    displayName: 'Horse',
    habitat: 'land',
    startSpeed: 340,
    maxSpeed: 700,
    speedRamp: base.speedRamp,
    jumpVelocity: -760,
    hp: 1,
    saddleAnchor: { x: -4, y: -42 },
    bodyHitbox: { width: 96, height: 70, offsetX: -48, offsetY: -35 },
    duckHitboxScale: base.duckHitboxScale,
    flavor: 'Reliable runner',
  },
  pig: {
    key: 'pig',
    displayName: 'Pig',
    habitat: 'land',
    startSpeed: 320,
    maxSpeed: 680,
    speedRamp: base.speedRamp,
    jumpVelocity: -700,
    hp: 2,
    saddleAnchor: { x: -2, y: -28 },
    bodyHitbox: { width: 80, height: 60, offsetX: -40, offsetY: -30 },
    duckHitboxScale: base.duckHitboxScale,
    flavor: 'Tough — takes 2 hits',
  },
  sheep: {
    key: 'sheep',
    displayName: 'Sheep',
    habitat: 'land',
    startSpeed: 350,
    maxSpeed: 740,
    speedRamp: base.speedRamp,
    jumpVelocity: -780,
    hp: 1,
    saddleAnchor: { x: -2, y: -32 },
    bodyHitbox: { width: 84, height: 62, offsetX: -42, offsetY: -31 },
    duckHitboxScale: base.duckHitboxScale,
    flavor: 'Balanced and woolly',
  },
  donkey: {
    key: 'donkey',
    displayName: 'Donkey',
    habitat: 'land',
    startSpeed: 360,
    maxSpeed: 760,
    speedRamp: base.speedRamp,
    jumpVelocity: -760,
    hp: 1,
    saddleAnchor: { x: -2, y: -22 },
    bodyHitbox: { width: 92, height: 68, offsetX: -46, offsetY: -34 },
    duckHitboxScale: base.duckHitboxScale,
    flavor: 'Steady and dependable',
  },
  duck: {
    key: 'duck',
    displayName: 'Duck',
    habitat: 'both',
    startSpeed: 350,
    maxSpeed: 700,
    speedRamp: base.speedRamp,
    jumpVelocity: -880,
    hp: 1,
    saddleAnchor: { x: 0, y: -28 },
    bodyHitbox: { width: 76, height: 56, offsetX: -38, offsetY: -28 },
    duckHitboxScale: base.duckHitboxScale,
    flavor: 'Flutters high',
  },
  otter: {
    key: 'otter',
    displayName: 'Otter',
    habitat: 'both',
    startSpeed: 350,
    maxSpeed: 690,
    speedRamp: base.speedRamp,
    jumpVelocity: -700,
    hp: 1,
    saddleAnchor: { x: -2, y: -28 },
    bodyHitbox: { width: 86, height: 54, offsetX: -43, offsetY: -27 },
    duckHitboxScale: base.duckHitboxScale,
    flavor: 'Quick and slippery',
  },
  clownfish: {
    key: 'clownfish',
    displayName: 'Clownfish',
    habitat: 'water',
    startSpeed: 360,
    maxSpeed: 760,
    speedRamp: base.speedRamp,
    jumpVelocity: -760,
    hp: 1,
    saddleAnchor: { x: 0, y: -22 },
    bodyHitbox: { width: 78, height: 58, offsetX: -39, offsetY: -29 },
    duckHitboxScale: base.duckHitboxScale,
    flavor: 'Round and cheerful',
  },
  stingray: {
    key: 'stingray',
    displayName: 'Stingray',
    habitat: 'water',
    startSpeed: 360,
    maxSpeed: 780,
    speedRamp: base.speedRamp,
    jumpVelocity: -700,
    hp: 1,
    saddleAnchor: { x: 0, y: -26 },
    bodyHitbox: { width: 110, height: 40, offsetX: -55, offsetY: -20 },
    duckHitboxScale: base.duckHitboxScale,
    flavor: 'Smooth glider',
  },
  turtle: {
    key: 'turtle',
    displayName: 'Sea Turtle',
    habitat: 'water',
    startSpeed: 300,
    maxSpeed: 640,
    speedRamp: base.speedRamp,
    jumpVelocity: -680,
    hp: 2,
    saddleAnchor: { x: -2, y: -30 },
    bodyHitbox: { width: 96, height: 56, offsetX: -48, offsetY: -28 },
    duckHitboxScale: base.duckHitboxScale,
    flavor: 'Tough shell, hp 2',
  },
  seal: {
    key: 'seal',
    displayName: 'Seal',
    habitat: 'water',
    startSpeed: 360,
    maxSpeed: 760,
    speedRamp: base.speedRamp,
    jumpVelocity: -780,
    hp: 1,
    saddleAnchor: { x: -2, y: -30 },
    bodyHitbox: { width: 90, height: 56, offsetX: -45, offsetY: -28 },
    duckHitboxScale: base.duckHitboxScale,
    flavor: 'Friendly and bouncy',
  },
};

export const ALL_ANIMAL_KEYS: AnimalKey[] = Object.keys(ANIMAL_STATS) as AnimalKey[];
